import React from "react";
import { BsCodeSlash } from "react-icons/bs";
import { SlSocialLinkedin } from "react-icons/sl";
import { VscGithubAlt } from "react-icons/vsc";
import { CiMail } from "react-icons/ci";
import { HiOutlineDocument } from "react-icons/hi";
import { motion } from "framer-motion";

export default function LinkBar(){

    const button_list = [
      {
        name: "Leetcode Profile",
        link: "https://leetcode.com/Algebros/",
        icon: <BsCodeSlash className="lg:text-xl" />,
      },
      {
        name: "LinkedIn",
        link: "https://www.linkedin.com/in/abhishek-sharma-9904891b8/",
        icon: <SlSocialLinkedin className="lg:text-xl" />,
      },
      {
        name: "Github",
        link: "https://github.com/Abhi-tech-09",
        icon: <VscGithubAlt className="lg:text-xl" />,
      },
      {
        name: "Gmail",
        link: "mailto:abhishekalien09@gmail.com",
        icon: <CiMail className="lg:text-xl" />,
      },
      {
        name: "Resume",
        link: "https://drive.google.com/file/d/1V1we6MXT_eqTR5l_ZZBmSk__wdZ8AXSl/view?usp=sharing",
        icon: <HiOutlineDocument className="lg:text-xl" />,
      },
    ];

    return(
        <div className='w-fit min-w-max mt-2 buttons rounded-xl p-2 m-2 lg:space-x-6 space-x-2 h-1/6'>
              {button_list.map((item, idx) => (
                <motion.div
                  initial={{ opacity: 0 , y:40}}
                  animate={{ opacity: 1 , y:0}}
                  transition={{ duration: 0.5 , delay: idx * 0.1}}
                  className='w-fit cursor-pointer tooltip tooltip-bottom border border-[#ffffff3c] rounded-[50%] lg:p-6 p-4 bg-[#ffffff1a] hover:bg-[#ffffff33] active:bg-[#ffffff80]'
                  data-tip={`${item.name}`}
                  style={{
                    "box-shadow": 
                    "rgba(66, 65, 65, 0.18) 10px 10px 40px, rgba(77, 72, 72, 0.2) -10px -10px 40px"
                  }}
                  >
                  <a className='w-fit' href={item.link} target="_blank">
                    {item.icon}
                  </a>
                </motion.div>
              ))}
            </div>
    )
}